import React, { useEffect } from "react";
import antd from "../assets/antd.png";
import aws from "../assets/aws.png";
import bitbucket from "../assets/bitbucket.png";
import bootstrap from "../assets/bootstrap.png";
import c_plus_plus from "../assets/c_plus_plus.png";

import chakra from "../assets/chakra.png";
import css from "../assets/css.png";
import docker from "../assets/docker.png";
import ethereum from "../assets/ethereum.png";

import ethers from "../assets/ethers.png";
import express from "../assets/express.png";
import firebase from "../assets/firebase.png";
import github from "../assets/github.png";
import graphql from '../assets/graphql.png'
import hardhat from '../assets/hardhat.png'

import html from "../assets/html.png";
import java from "../assets/java.png";
import javascript from '../assets/javascript.png'
import jira from '../assets/jira.png'

import kubernetes from "../assets/kubernetes.png";
import mongodb from "../assets/mongodb.png";
import multiversx from '../assets/multiversx.png'
import near from '../assets/near.png'

import nest from "../assets/nest.png";
import next from "../assets/next.png";
import node from '../assets/node.png'
import pinata from '../assets/pinata.png'

import react from "../assets/react.png";
import rust from "../assets/rust.png";
import solana from '../assets/solana.png'
import solidity from '../assets/solidity.png'
import sql from '../assets/sql.png'

import tailwind from "../assets/tailwind.png";
import typescript from "../assets/typescript.png";
import vue from '../assets/vue.png'
import web3 from '../assets/web3.png'

import web3auth from "../assets/web3auth.png";
import wordpress from "../assets/wordpress.png";

import Aos from 'aos';
import 'aos/dist/aos.css';

import golang from '../assets/golang.png'
import PHP from '../assets/PHP.png'
import Python from '../assets/python.png'
import Csharp from '../assets/c_sharp.png'

import ruby from '../assets/ruby.png'
import nuxt from '../assets/nuxt.png'

import angular from '../assets/angular.png'
import vuetify from '../assets/vuetify.png'

import mui from '../assets/mui.png'
import gin from '../assets/gin.png'
import gorilla from '../assets/gorilla.svg'
import django from '../assets/django.png'
import flask from '../assets/flask.svg'
import fastAPI from '../assets/fastAPI.svg'
import laravel from '../assets/laravel.png'
import symfony from '../assets/symfony.png'
import springboot from '../assets/springboot.png'
import mysql from '../assets/mysql.png'
import oracle from '../assets/oracle.png'
import postgres from '../assets/postgresql.svg'
import AWS from '../assets/aws.png'
import GCP from '../assets/gcp.png'
import web3modal from '../assets/web3modal.png'
import vercel from '../assets/vercel.svg'
import netlify from '../assets/netlify.png'
import thegraph from '../assets/thegraph.svg'
import heroku from '../assets/heroku.png'
import wagmi from '../assets/wagmi.png'
import dune from '../assets/dune.svg'
import rainbow from '../assets/rainbow.png'
import snapshot from '../assets/snapshot.png'

const Skills = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

  const programmingLang =[
    {
      logo:solidity,
      title:'solidity'
    },
    {
        logo: typescript,
        title: 'typescript',
      },
    {
        logo:javascript,
        title:'javascript'
    },
    {
        logo:golang,
        title:'golang'
    },
    {
        logo:PHP,
        title:'PHP'
    },
    {
        logo:Python,
        title:'python'
    },
    {
        logo:java,
        title:"java"
    },
    {
        logo:rust,
        title:'rust'
    },
    {
        logo:Csharp,
        title:'C#'
    },
    {
        logo:ruby,
        title:'ruby'
    },
    {
        logo: c_plus_plus,
        title: 'C++',
      },
  ]

  const frontEndSkills =[
   
    {
        logo: html,
        title: 'Html',
    },
    {
      logo:react,
      title:'React'
    },
    {
        logo: next,
        title: 'next.js',
    },
    
      {
        logo: vue,
        title: 'vue.js',
      },
      {
        logo: wordpress,
        title: 'wordpress',
      },
      {
        logo: nuxt,
        title: 'nuxt.js'
      },
      {
        logo:angular,
        title:'angular'
      },

      {
        logo:vuetify,
        title:'vuetify'
      },
  ]

  const frontEndLibraries = [
    {
        logo: antd,
        title: 'Ant Design',
      },
      {
        logo: bootstrap,
        title: 'Bootstrap'
      },
      {
        logo: tailwind,
        title: 'tailwindcss',
      },
      {
        logo:mui,
        title:'material ui'
      },
      {
        logo:chakra,
        title:'chakra ui'
      },

  ]

const backendSkills = [
    {
        logo: node,
        title: 'node.js',
      },
    {
        logo: express,
        title: 'Express.js',
      },
      {
        logo: nest,
        title: 'nest.js',
      },
    {
        logo:gin,
        title:"gin"
    },
    {
        logo:gorilla,
        title:'gorilla/mux'
    },
    {
        logo:django,
        title:'django'
    },
    {
        logo:flask,
        title:'flask'
    },
    {
        logo:fastAPI,
        title:'fastAPI'
    },
    {
        logo:laravel,
        title:'laravel'
    },
    {
        logo:symfony,
        title:'symfony'
    },
    {
        logo:springboot,
        title:'spring boot'
    }

]
const dataBase = [
    {
        logo:mongodb,
        title:'MongoDB'
    },
    {
        logo:mysql,
        title:'MySQL'
    },
    {
        logo:oracle,
        title:'oracle'
    },
    {
        logo:postgres,
        title:'postgres'
    },
    {
        logo:firebase,
        title:'firebase'
    }
]

const clouds = [
    {
        logo:AWS,
        title:'AWS',
    },
    {
        logo:netlify,
        title:'netlify'
    },
    {
        logo:vercel,
        title:'vercel'
    },
    {
        logo:heroku,
        title:'heroku'
    },
    {
        logo:GCP,
        title:'GCP'
    },
    {
        logo:docker,
        title:'docker'
    },
    {
        logo:github,
        title:'git'
    },
    {
        logo:jira,
        title:'jira'
    },
    {
        logo:bitbucket,
        title:'BitBucket'
    },
    {
        logo: kubernetes,
        title: 'Kubernetes',
      },

]

const blockchain = [
    {
        logo: ethereum,
        title: 'Ethereum',
      },
      {
        logo: ethers,
        title: 'Ethers.js',
      },  
      {
        logo: hardhat,
        title: 'Hardhat',
      },
      {
        logo: multiversx,
        title: 'multiversx',
      },
      {
        logo: near,
        title: 'near',
      },
      {
        logo: pinata,
        title: 'pinata',
      },
      {
        logo: solana,
        title: 'solana',
      },
      {
        logo: web3,
        title: 'web3.js',
      },
      {
        logo: web3auth,
        title: 'web3auth',
      },
      {
        logo:wagmi,
        title:'wagmi'
      },
      {
        logo:web3modal,
        title:'web3modal'
      },
      {
        logo:thegraph,
        title:'thegraph'
      },
      {
        logo:dune,
        title:'dune'
      },
      {
        logo: snapshot,
        title:'snapshot'
      },{
        logo:rainbow,
        title:'rainbow'
      }

]

  return (
    <div name="skills" className="bg-[#0a192f]  text-gray-300 w-full pt-72 pb-96">
      {/* container */}
      <div className=" max-w-[1000px]  mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div data-aos='slide-right'>
          <p className="text-4xl font-bold border-b-2 border-pink-600 inline">Skills
          </p>
          <p className="py-2">These are the technologies I've worked with<span className="text-pink-600">...</span></p>
        </div>
        <h3 className="text-3xl mt-10">Programming Languages</h3>
        <div className=" w-full grid grid-cols-2 sm:grid-cols-8 gap-4 text-center py-8" data-aos='zoom-in-right'>
          {
            programmingLang.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          }
        </div>
        <h3 className="text-3xl mt-10">Front end</h3>
        <div className=" w-full grid grid-cols-2 sm:grid-cols-8 gap-4 text-center py-8" data-aos='zoom-in-right'>
          {
            frontEndSkills.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          }
          {
            frontEndLibraries.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          }
          
        </div>
        <h3 className="text-3xl mt-10">Back End</h3>
        <div className=" w-full grid grid-cols-2 sm:grid-cols-8 gap-4 text-center py-8" data-aos='zoom-in-right'>
          {
            backendSkills.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          }
        </div>
        <h3 className="text-3xl mt-10">Database</h3>
        <div className=" w-full grid grid-cols-2 sm:grid-cols-8 gap-4 text-center py-8" data-aos='zoom-in-right'>
         {
            dataBase.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          } 
        </div>
        <h3 className="text-3xl mt-10">Cloud & DevOps</h3>
        <div className=" w-full grid grid-cols-2 sm:grid-cols-8 gap-4 text-center py-8" data-aos='zoom-in-right'>
          {
            clouds.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          }
        </div>

        <h3 className="text-3xl mt-10">Blockchain</h3>
        <div className=" w-full grid grid-cols-2 sm:grid-cols-8 gap-4 text-center py-8" data-aos='zoom-in-right'>
          {
            blockchain.map((item, index) => (
              <div className=" shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded-md " key={index}>
                <img className="w-10 mx-auto" src={item.logo} alt="html icon" style={{ width: '40px', height: '40px' }} />
                <p className="my-2" style={{ textTransform: 'capitalize' }}>{item.title}</p>
              </div>
            ))
          }
        </div>
        
      </div>
    </div>
  );
};

export default Skills;
